import React from 'react';
import styled from 'styled-components';

const RodapeContainer = styled.footer`
    position: fixed;
    bottom: 0;
    left: 200px;
    right: 0;
    height: 50px;
    background-color: #008080;
    color: white;
    font-family: 'Roboto', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    z-index: 900;
    
    /* Desktop: sidebar width 240px */
    @media (min-width: 1201px) {
        left: 200px;
    }

    /* Tablet: when sidebar is collapsed, content margin is ~60px */
    @media (min-width: 768px) and (max-width: 1200px) {
        left: 60px;
    }

    /* Small devices: footer becomes part of document flow */
    @media (max-width: 767px) {
        position: static;
        width: 100%;
        left: 0;
    }
    
    @media (max-width: 600px) {
        height: 45px;
        font-size: 11px;
    }
    
    @media (max-width: 400px) {
        height: 40px;
        font-size: 10px;
    }
`;

const Rodape = () => {
  return <RodapeContainer>© 2025 Testemunho Público Especial - DF</RodapeContainer>;
};

export default Rodape;
